__turbopack_context__.v({
  "breadcrumbWrapper": "FolderBreadcrumbs-module__VBxRDa__breadcrumbWrapper",
});
